<div class="sidebar" [ngClass]="{'expanded': isMenuExpanded}">
  <div class="burger-menu" (click)="toggleMenu()">
    &#9776; <!-- Burger Icon -->
  </div>
  <div class="menu-items" *ngIf="isMenuExpanded">
    <div class="menu-header">Kanäle</div>
    <div class="menu-item selected">{{ 'widgets.chat.general' | translate }}</div>
  </div>
</div>

<div #chatWidgetContainer class="chat-container">
  <!-- Projektname und später Chatname -->
  <div class="chat-header">
    <div class="project-name">{{ 'widgets.chat.general' | translate }}</div>

    <mat-slide-toggle (change)="toggleAiState()" [checked]="isActionItemShowing">
      {{ toggleText }}
    </mat-slide-toggle>

    <!-- Counter-Display -->
    <div class="action-item-counter">
      <span class="counter">
          <mat-icon class="icon open">hourglass_empty</mat-icon>:
        <span class="number">{{ openActionItemsCount }}</span>
      </span>
      <span class="counter">
          <mat-icon class="icon accepted">check_circle</mat-icon>:
        <span class="number">{{ acceptedActionItemsCount }}</span>
      </span>
      <span class="counter">
          <mat-icon class="icon rejected">cancel</mat-icon>:
        <span class="number">{{ rejectedActionItemsCount }}</span>
      </span>
    </div>
  </div>

  <!-- Nachrichtenbereich -->
  <div #scrollMe (scroll)="onScroll()" class="chat-window">
    <div *ngIf="!groupedChatItems.length" class="empty-message-container">
      {{ 'widgets.chat.noMessageInChannel' | translate }}
    </div>

    <ng-container *ngFor="let group of groupedChatItems">
      <div class="group-date">
        <ng-container *ngIf="group.date === currentDate">
          {{ 'widgets.chat.today' | translate }}
        </ng-container>
        <ng-container *ngIf="group.date !== currentDate">
          {{ group.date }}
        </ng-container>
      </div>
      <ng-container *ngFor="let item of group.items">
        <app-chat-widget-action-item *ngIf="isActionItemShowing && isActionItem(item)" [actionItem]="item"
        (actionItemUpdated)="handleActionItemUpdate($event)"
        (issuecardClosed)="issuecardClosed.emit($event)"
        (issueRemoved)="issueRemoved.emit($event)">
        </app-chat-widget-action-item>
        <div *ngIf="isMessage(item)" (mouseover)="markAsRead(item)" class="message" [ngClass]="{
    'sent': isMe(item),
    'unread': !isMe(item) && !item.isRead,
    'received': !isMe(item)
  }">
          <div class="avatar-container" *ngIf="!isMe(item)">
            <img class="avatar" [src]="getMemberAvatar(item.senderId)" alt="Avatar">
          </div>
          <div class="message-content">
            <div class="message-header">
              <div *ngIf="!isMe(item)" class="sender-name">
                {{ item.senderId | emailName }}
              </div>
              <div class="timestamp">
                <span class="time">{{ item.timestamp | date:'HH:mm' }}</span>
                <span class="unread-message">{{ !item.isRead && !isMe(item) ? 'unread' : '' }}</span>
              </div>
            </div>
            <div [ngClass]="{'ingored-for-analysis': item.isKIIgnored}" class="message-body">
              <div *ngIf="!item.issueId" (contextmenu)="onRightClick($event, item)"
                   class="message-text selectable"
                   (appOutsideClick)="contextMenuVisible = false">
                {{ item.content }}
              </div>
              <div *ngIf="item.issueId">
                <span class="issue-text"> {{ 'widgets.chat.newIssue' | translate }}</span>
                <button
                  class="openIssue"
                  (click)="handleIssueClicked($event, item.issueId)">
                  {{ item.content }}
                </button>
              </div>
              <div *ngIf="item.isKIIgnored" class="ai-ignored">
                @KI-Ignore
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <button mat-icon-button class="go-to-bottom" *ngIf="showScrollButton" (click)="scrollToBottom()">
      <mat-icon>arrow_downward</mat-icon>
    </button>
  </div>

  <!-- Eingabebereich für neue Nachrichten -->
  <div class="chat-actions-container">
    <div *ngIf="allMessagesAnalyzed" class="chat-messages-analyzed-alert">
      Analyse der Chat-Nachrichten abgeschlossen.
      <mat-icon class="material-symbols-outlined">check_circle_outline</mat-icon>
    </div>
    <div *ngIf="aiState === 'analyzing'" class="ai-text-state">
      KI analysiert Chat Nachrichten<span class="dots"></span>
    </div>
    <div *ngIf="aiState === 'generating'" class="ai-text-state">
      KI generiert Issue Vorschläge<span class="dots"></span>
    </div>
    <div class="message-input-container">
    <textarea #autoResizeTextarea class="message-input autoResizeTextareaHeight" type="text" rows="1"
              [(ngModel)]="newMessage.content" (keyup.enter)="sendMessage(newMessage.content)"
              (input)="adjustTextareaHeight()"
              [placeholder]="'widgets.chat.typeInMessage' | translate"></textarea>
      <button [ngClass]="{
      enabled: newMessage.isKIIgnored,
      disabled: !newMessage.isKIIgnored
      }" class="ki-ignore" (click)="setKIIgnore()">
        @KI-Ignore
      </button>
      <button class="sendButton" mat-raised-button color="accent" (click)="sendMessage(newMessage.content)">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>

  <div #contextMenu class="context-menu" [ngClass]="{'hidden': !contextMenuVisible}">
    <button class="context-menu-button" mat-raised-button (click)="createIssue($event)">
      {{ 'widgets.chat.newIssue' | translate }}
    </button>
    <button class="context-menu-button" mat-raised-button (click)="requestAnalysis($event)">
      Ask AI!
    </button>
  </div>
</div>

<div class="issuecard-hidden">
  <template #newBklIssue></template>
</div>
